"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonPinnedSection = exports.PersonPinnedSectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var section_1 = require("../elements/section");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_entities_1 = require("../../hooks/use-entities");
var use_lang_1 = require("../../hooks/use-lang");
var entity_link_value_1 = require("./entity-link-value");
var icons_1 = require("../icons");
var grid_1 = require("../elements/grid");
var menu_context_1 = require("../context/menu-context");
var use_app_state_1 = require("../../hooks/use-app-state");
var react_spinners_1 = require("react-spinners");
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
exports.PersonPinnedSectionDefaultProps = {
  title: 'Pinned Items'
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PinnedGridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 0;\n    margin-top: ", ";\n  "], ["\n    border-radius: 0;\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(section_1.Section)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), PinnedGridStyles)
};
var PersonPinnedSection = function (props) {
  var className = props.className,
    entity = props.entity,
    title = props.title;
  var person = (0, use_active_person_1.useActivePerson)().person;
  var client = (0, client_1.useApolloClient)();
  var _a = __read((0, use_app_state_1.useAppState)(), 2),
    appState = _a[0],
    setAppState = _a[1];
  var entities = (0, use_entities_1.useEntities)();
  var _b = __read((0, client_1.useMutation)(entities.Pin.delete.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 1),
    deleteMutation = _b[0];
  var t = (0, use_lang_1.useLang)();
  if (entity.pinnedItems && !!entity.pinnedItems.length) {
    return react_1.default.createElement(My.Container, {
      icon: icons_1.Icons.Entities.Pin,
      controls: appState.isPinning && react_1.default.createElement(react_spinners_1.ClipLoader, {
        size: 18,
        color: "#CCCCCC"
      }),
      title: t(title),
      className: className
    }, react_1.default.createElement(My.Grid, {
      columns: 2,
      spacing: 4,
      items: (0, lodash_1.filter)(entity.pinnedItems, function (_a) {
        var item = _a.item;
        return !!(item === null || item === void 0 ? void 0 : item.entity);
      }).map(function (_a) {
        var id = _a.id,
          item = _a.item;
        return react_1.default.createElement(menu_context_1.MenuProvider, {
          value: {
            preventDelete: true,
            extraItems: [{
              label: 'Delete Pin',
              value: 'DELETE_PIN',
              icon: react_1.default.createElement(icons_1.Icons.MinusCircle, null),
              onClick: function (event) {
                return __awaiter(void 0, void 0, void 0, function () {
                  var newPerson;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        event.stopPropagation();
                        event.preventDefault();
                        setAppState(__assign(__assign({}, appState), {
                          isPinning: true
                        }));
                        return [4 /*yield*/, deleteMutation({
                          variables: {
                            id: id
                          }
                        })];
                      case 1:
                        _a.sent();
                        if (person) {
                          newPerson = __assign(__assign({}, person), {
                            pinnedItems: (0, lodash_1.filter)(person.pinnedItems, function (_a) {
                              var pinnedId = _a.id;
                              return pinnedId !== id;
                            })
                          });
                          setAppState(__assign(__assign({}, appState), {
                            activePerson: __assign(__assign({}, appState.activePerson), {
                              person: newPerson
                            }),
                            isPinning: false
                          }));
                        } else {
                          setAppState(__assign(__assign({}, appState), {
                            isPinning: false
                          }));
                        }
                        return [2 /*return*/];
                    }
                  });
                });
              }
            }]
          }
        }, react_1.default.createElement(entity_link_value_1.EntityLinkValue, {
          showMenu: true,
          key: "pinned-".concat(id),
          entity: item.entity
        }));
      })
    }));
  }
  return null;
};
exports.PersonPinnedSection = PersonPinnedSection;
exports.PersonPinnedSection.defaultProps = exports.PersonPinnedSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;